<template>

    <div>
        <div class="box box-solid">
            <div class="overlayview servertable-active-columns" v-show="showColumns">
                <table>
                    <thead>
                        <tr>
                            <td colspan="2">{{ lang.get('servertable.allcolumns') }}</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="column in columns">
                            <td><input type="checkbox" :id="'cbox-' + column.id" :checked="column.active" :value="column.id" @change="toggleColumn(column)" /></td>
                            <td><label :for="'cbox-' + column.id" v-text="column.name"></label></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="box-header" style="position:relative;">
                <h2 class="box-title">Facturen</h2>
                <div class="box-tools">
                    <div class="btn-group btn-group-sm">
                        <button
                            class="btn btn-default"
                            @click="toggleColumns()"
                        >
                            <i class="mdi mdi-format-columns"></i>
                        </button>
                        <json-excel
                            :data="getJSONData"
                            :fields="getJSONFields"
                            :title="'Facturen. Gegenereerd op: ' + moment().format('DD-MM-YYYY HH:mm')"
                            v-tooltip="'Exporteer naar Excel'"
                            class="btn btn-default"
                        >
                            <i class="mdi mdi-file-excel-box"></i>
                        </json-excel>
                        <button
                            class="btn btn-default"
                            @click="exportToPdf()"
                            v-tooltip="'Exporteer naar PDF'"
                        >
                            <i class="mdi mdi-file-pdf-box"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="box-body table-responsive no-padding">
                <table class="table table-striped table-hover table-fixed" id="project-invoices-table">
                    <thead>
                        <tr>
                            <th v-if="activeColumn('name')">Taak</th>
                            <th v-if="activeColumn('fee')" class="text-right">Contract fee</th>
                            <th v-if="activeColumn('target_budget')" class="text-right">Target budget</th>
                            <th v-if="activeColumn('expected_at')">Verwacht</th>
                            <th v-if="activeColumn('date')">Verzenddatum</th>
                            <th v-if="activeColumn('invoice_nr')">Factuurnummer</th>
                            <th v-if="activeColumn('amount')" class="text-right">Bedrag</th>
                            <th v-if="activeColumn('amount_days')" class="text-right">Aantal dagen</th>
                        </tr>
                    </thead>
                    <tbody v-if="tasks.length === 0">
                        <tr>
                            <td :colspan="activeColumnCount">Er zijn geen taken beschikbaar binnen dit project</td>
                        </tr>
                    </tbody>
                    <tbody v-for="task in tasks">
                        <tr>
                            <td v-if="activeColumn('name')">
                                <router-link :to="{name:'projects.details.tasks', params:{uuid:projectUuid,task_uuid:task.uuid}}">{{ task.name }}</router-link>
                            </td>
                            <td v-if="activeColumn('fee')" class="text-right">{{ task.fee | toCurrency }}</td>
                            <td v-if="activeColumn('target_budget')" class="text-right">{{ task.target_budget | toCurrency }}</td>
                            <td v-if="activeColumn('expected_at')">&nbsp;</td>
                            <td v-if="activeColumn('date')">&nbsp;</td>
                            <td v-if="activeColumn('invoice_nr')">&nbsp;</td>
                            <td v-if="activeColumn('amount')">&nbsp;</td>
                            <td v-if="activeColumn('amount_days')">&nbsp;</td>
                        </tr>
                        <tr v-if="task.invoices.length === 0">
                            <td :colspan="activeColumnCount" class="text-center"><em>Er zijn geen facturen beschikbaar binnen deze taak</em></td>
                        </tr>
                        <tr v-for="invoice in task.invoices" :class="{'text-red':invoice.send === true && invoice.paid !== true}">
                            <td v-if="activeColumn('name')">&nbsp;</td>
                            <td v-if="activeColumn('fee')">&nbsp;</td>
                            <td v-if="activeColumn('target_budget')">&nbsp;</td>
                            <td v-if="activeColumn('expected_at')">{{ moment(invoice.expected_at).format("DD-MM-YYYY") }}</td>
                            <td v-if="activeColumn('date')">{{ invoice.date === null ? '' : moment(invoice.date).format("DD-MM-YYYY") }}</td>
                            <td v-if="activeColumn('invoice_nr')">{{ invoice.invoice_nr }}</td>
                            <td v-if="activeColumn('amount')" class="text-right">
                                <a
                                    @click="openInvoicesModal(invoice)"
                                    style="display:block;"
                                >
                                    {{ invoice.amount | toCurrency }}
                                </a>
                            </td>
                            <td v-if="activeColumn('amount_days')" class="text-right">
                                <span v-if="invoice.paid === true || invoice.send !== true">&ndash;</span>
                                <span v-else class="text-red">{{ moment().diff(moment(invoice.date), 'days') + 1 }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td v-if="activeColumn('name')">&nbsp;</td>
                            <td v-if="activeColumn('fee')">&nbsp;</td>
                            <td v-if="activeColumn('target_budget')">&nbsp;</td>
                            <td v-if="activeColumn('expected_at')">&nbsp;</td>
                            <td v-if="activeColumn('date')">&nbsp;</td>
                            <td v-if="activeColumn('invoice_nr')">&nbsp;</td>
                            <td v-if="activeColumn('amount')" class="text-right"><strong>{{ task.totalinvoices | toCurrency}}</strong></td>
                            <td v-if="activeColumn('amount_days')">&nbsp;</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td v-if="activeColumn('name')">&nbsp;</td>
                            <td v-if="activeColumn('fee')">&nbsp;</td>
                            <td v-if="activeColumn('target_budget')">&nbsp;</td>
                            <td v-if="activeColumn('expected_at')">&nbsp;</td>
                            <td v-if="activeColumn('date')">&nbsp;</td>
                            <td v-if="activeColumn('invoice_nr')">&nbsp;</td>
                            <td v-if="activeColumn('amount')">&nbsp;</td>
                            <td v-if="activeColumn('amount_days')">&nbsp;</td>
                        </tr>
                        <tr class="font-weight-bold">
                            <td v-if="activeColumn('name')" class="text-right">Totaal</td>
                            <td v-if="activeColumn('fee')" class="text-right">{{ totalFee | toCurrency }}</td>
                            <td v-if="activeColumn('target_budget')" class="text-right">{{ totalTargetBudget | toCurrency }}</td>
                            <td v-if="activeColumn('expected_at')">&nbsp;</td>
                            <td v-if="activeColumn('date')">&nbsp;</td>
                            <td v-if="activeColumn('invoice_nr')">&nbsp;</td>
                            <td v-if="activeColumn('amount')" class="text-right">{{ totalBudget | toCurrency }}</td>
                            <td v-if="activeColumn('amount_days')">&nbsp;</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div class="overlay" v-if="loading">
                <i class="fa fa-refresh fa-spin"></i>
            </div>
        </div>
        <business-invoice-modal ref="invoiceModal"></business-invoice-modal>
    </div>

</template>

<script>

    import axios from 'axios';
    import moment from 'moment';
    import BusinessInvoiceModal from "../Business/InvoiceModal";
    import JsonExcel from "vue-json-excel";
    import jsPDF from "jspdf";
    import Lang from '../../Lang';

    export default {

        components: {
            BusinessInvoiceModal,
            JsonExcel,
        },

        computed: {

            activeColumnCount() {
                return this.columns.filter(col => col.active === true).length;
            },

            getJSONFields() {
                let row = {};
                if (this.activeColumn("name")) { row["Taak"] = "name"; }
                if (this.activeColumn("fee")) { row["Contract fee"] = "fee"; }
                if (this.activeColumn("target_budget")) { row["Target budget"] = "target_budget"; }
                if (this.activeColumn("expected_at")) { row["Verwacht"] = 'expected_at'; }
                if (this.activeColumn("date")) { row["Verzenddatum"] = 'date'; }
                if (this.activeColumn("invoice_nr")) { row["Factuurnummer"] = 'invoice_nr'; }
                if (this.activeColumn("amount")) { row["Bedrag"] = 'amount'; }
                if (this.activeColumn("amount_days")) { row["Aantal dagen"] = 'amount_days'; }
                return row;
            },

            getJSONData() {
                let data = [];
                this.tasks.forEach(task => {
                    data.push(this.getTaskRow(task));
                    task.invoices.forEach(invoice => {
                        data.push(this.getInvoiceRow(invoice));
                    });
                });
                return data;
            },

            totalFee() {
                let total = 0;
                this.tasks.forEach(task => total += task.fee);
                return total;
            },

            totalTargetBudget() {
                let total = 0;
                this.tasks.forEach(task => total += task.target_budget);
                return total;
            },

            totalBudget() {
                let total = 0;
                this.tasks.forEach(task => {
                    task.invoices.forEach(invoice => total += invoice.amount);
                });
                return total;
            },
        },

        data() {
            return {
                columns:[
                    {
                        id:"name",
                        name:"Taak",
                        active:true,
                    },
                    {
                        id:"fee",
                        name:"Contract fee",
                        active:true,
                    },
                    {
                        id:"target_budget",
                        name:"Target Budget",
                        active:true,
                    },
                    {
                        id:"expected_at",
                        name:"Verwacht",
                        active:true,
                    },
                    {
                        id:"date",
                        name:"Verzenddatum",
                        active:true,
                    },
                    {
                        id:"invoice_nr",
                        name:"Factuurnummer",
                        active:true,
                    },
                    {
                        id:"amount",
                        name:"Bedrag",
                        active:true,
                    },
                    {
                        id:"amount_days",
                        name:"Aantal dagen",
                        active:true,
                    },
                ],
                lang:Lang,
                loading: true,
                moment: moment,
                showColumns:false,
                tasks:[],
            }
        },

        methods: {

            activeColumn(id) {
                let column = this.columns.filter(col => col.id === id);
                if (column.length !== 1) {
                    return false;
                }
                return column[0].active;
            },

            exportToPdf() {
                let doc = new jsPDF({orientation:'landscape'});
                doc.autoTable({html:'#project-invoices-table'});
                doc.save('project-invoices.pdf');
            },

            getInvoices() {
                axios.get(this.invoicesUri)
                    .then(resp => this.tasks = resp.data.data)
                    .catch(() => this.$snotify.error("Er is een fout opgetreden bij het ophalen van de factuur gegevens"))
                    .finally(() => this.loading = false);
            },

            getInvoiceRow(invoice) {
                let format = (value) => parseFloat(value / 100).toFixed(2);
                return {
                    name: '',
                    fee: '',
                    target_budget: '',
                    expected_at: moment(invoice.expected_at).format("DD-MM-YYYY"),
                    date: invoice.date !== null ? moment(invoice.date).format("DD-MM-YYYY") : "",
                    invoice_nr: invoice.invoice_nr,
                    amount: format(invoice.amount),
                    amount_days: invoice.paid === true || invoice.send !== true ? '-' : moment().diff(moment(invoice.date), 'days') + 1,
                };
            },

            getTaskRow(task) {
                let format = (value) => parseFloat(value / 100).toFixed(2);
                return {
                    name: task.name,
                    fee: format(task.fee),
                    target_budget: format(task.target_budget),
                    expected_at: '',
                    date: '',
                    invoice_nr: '',
                    amount: '',
                    amount_days: '-',
                };
            },

            openInvoicesModal(invoice) {
                this.$refs.invoiceModal.openModal(invoice.taskurl, {}, invoice);
            },

            toggleColumn(column) {
                column.active = !column.active;
            },

            toggleColumns() {
                this.showColumns = !this.showColumns;
            },

            hideColumns() {
                this.showColumns = false;
            },
        },

        mounted() {
            this.getInvoices();
        },

        name:"ProjectInvoices",

        props: {
            invoicesUri: { required:true },
            projectUuid: { required:true },
        },

    }

</script>

<style lang="scss">
    $base-row-height: 30px;
    $base-border-color: #ccc;

    .font-weight-bold {
        font-weight:700;
    }
    .overlayview {
        position:absolute;
        right:3px;
        top:$base-row-height;
        background-color:#fff;
        border-left:1px solid $base-border-color;
        border-bottom:1px solid $base-border-color;
        box-shadow:-2px 2px 8px #ccc;
        padding:10px 12px;
        max-height:100%;
        overflow-y:auto;
        z-index:601;

        table th,
        table td {
            padding:2px 4px;
        }

        table th { font-weight:700; }

        label {
            font-weight:400;
            margin:0;
        }
    }

</style>
